import axios from 'axios';
import { API_URL } from '../env';
import { normalize } from './helpers';

/** The rulebook's text sections, in book order. */
async function all() {
  const response = await axios.get(`${API_URL}/rules`);

  return normalize(response.data);
}

/** The rulebook's photographed pages, cover first. */
async function allPages() {
  const response = await axios.get(`${API_URL}/rules/pages`);

  return normalize(response.data);
}

export {
  all,
  allPages,
};
